module.exports = __webpack_public_path__ + "img/Simultan.3012caa5.jpg";